
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  name: 'AppSocialMediaInfoBar',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    typeString() {
      if (
        ![
          SocialMediaType.INSTAGRAM,
          SocialMediaType.NAVER_CAFE,
          SocialMediaType.NAVER_BLOG,
          SocialMediaType.YOUTUBE
        ].includes(this.review.social_media_type)
      )
        return '';

      const type = SocialMediaType.toKey(
        this.review.social_media_type
      ).toLowerCase();
      return type.includes('naver') ? 'naver' : type;
    },
    socialMediaUrl() {
      switch (this.review.social_media_type) {
        case SocialMediaType.INSTAGRAM:
          return 'instagram.com';
        case SocialMediaType.NAVER_CAFE:
          return 'cafe.naver.com';
        case SocialMediaType.NAVER_BLOG:
          return 'blog.naver.com';
        case SocialMediaType.YOUTUBE:
          return 'youtube.com';
        default:
          return '';
      }
    }
  }
};
